import { CREATE_BASVURU_WITH_ALTSUREC } from "../constants/requestUrls";

import { postRequest } from "../request";

const CreateBasvuruWithAltSurec = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  return postRequest({ url: CREATE_BASVURU_WITH_ALTSUREC, data });
}

export default CreateBasvuruWithAltSurec;